class CartItems extends window.BAO.CustomElement() {
  _loading = false

  constructor () {
    super()

    this.sections = window.BAO.sectionRenderer.cartSections
  }

  connectedCallback () {
    super.connectedCallback()

    this.refresh()
  }

  async refresh () {
    this.loading = true

    const { sectionRenderer } = window.BAO
    const sections = await sectionRenderer.fetch(
      this.sections.map(s => s.section),
    )

    this.renderSections(sections)

    this.loading = false
  }

  setupListeners () {
    super.setupListeners()

    this.onBeforeCartAdd = this.onBeforeCartAdd.bind(this)
    this.onAfterCartAdd = this.onAfterCartAdd.bind(this)
    this.onCartChangeFromStorage = this.onCartChangeFromStorage.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD,
      this.onBeforeCartAdd,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_MULTIPLE_ADD,
      this.onBeforeCartAdd,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.onBeforeCartAdd,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
      this.onAfterCartAdd,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_MULTIPLE_ADD,
      this.onAfterCartAdd,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.onAfterCartAdd,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChange,
    )

    window.addEventListener('storage', this.onCartChangeFromStorage)
  }

  onBeforeCartAdd () {
    this.loading = true
  }

  onAfterCartAdd (event) {
    if ('sections' in event.detail.state) {
      this.renderSections(event.detail.state.sections)
    }

    if (window.drawers.activeDrawerKey === 'quick-buy') {
      window.drawers.activeDrawerKey = ''
    }

    this.loading = false
  }

  onCartChange (event) {
    if ('sections' in event.detail.state) {
      window.localStorage.setItem(
        'cartUpdate',
        JSON.stringify(event.detail.state.sections),
      )
    }
  }

  onCartChangeFromStorage (event) {
    if (event.key !== 'cartUpdate') return

    this.renderSections(JSON.parse(event.newValue))
  }

  get loading () {
    return this._loading
  }

  set loading (loading) {
    this._loading = loading

    this.classList.toggle(this.loadingClass, loading)
  }

  get loadingClass () {
    return this.getAttribute('loading-class')
  }
}

if (!window.customElements.get('cart-items')) {
  window.customElements.define('cart-items', CartItems)
}
